var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vendor-display-setting"},[_c('edit',{attrs:{"fs":_vm.vendorDisplayFields,"api":"settings","id":"vendor-display","title":"Vendor Display"},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }